import { Path, SVG } from '@wordpress/primitives';

export default (
	<SVG xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" style={ { fill: "none" } } stroke="currentColor" strokeWidth="1.5">
		<Path d="M12 4V19M7 14L12 19L17 14" vectorEffect="non-scaling-stroke" />
	</SVG>
);
